import { KontoinhaberEnum } from '../v2024';

export const KontoinhaberEnumLabels = {
    _1: '1' as KontoinhaberEnum,
    _2: '2' as KontoinhaberEnum,
    _3: '3' as KontoinhaberEnum,
    _99: '99' as KontoinhaberEnum
};

